export default {"src":"/_next/static/media/youtube-light.c89f3f69.svg","height":10,"width":14,"blurWidth":0,"blurHeight":0};